import Container from "../Container";
import { Content } from "@/types/PropTypes";
import { ContentMarkup } from "./HistoryOfSudoku.components";

const HistoryOfSudoku = ({ content }: Content) => {
  return (
    <Container>
      <ContentMarkup content={content} />
    </Container>
  );
};

export default HistoryOfSudoku;
